/** Demo sub-user ids from mockSubUsersData (wlDemoData.js). */
export const SUB_USER_IDS = {
  DEMO: 201,
  CATALOG: 202,
};

const BY_ID = {
  artists: { 2: SUB_USER_IDS.DEMO, 6: SUB_USER_IDS.CATALOG, 10: SUB_USER_IDS.DEMO },
  releases: { 2: SUB_USER_IDS.DEMO, 5: SUB_USER_IDS.CATALOG, 8: SUB_USER_IDS.DEMO, 10: SUB_USER_IDS.CATALOG },
  labels: { 2: SUB_USER_IDS.DEMO, 4: SUB_USER_IDS.CATALOG },
  musiclinks: { 11: SUB_USER_IDS.DEMO, 12: SUB_USER_IDS.CATALOG, 13: SUB_USER_IDS.DEMO },
  musiclinks_urlparts: { 10: SUB_USER_IDS.DEMO, 11: SUB_USER_IDS.CATALOG, 12: SUB_USER_IDS.DEMO },
  promotions: { 30: SUB_USER_IDS.DEMO, 31: SUB_USER_IDS.CATALOG },
  "recipient-lists": { 2: SUB_USER_IDS.DEMO, 4: SUB_USER_IDS.CATALOG },
  "link-landingpages": { 2: SUB_USER_IDS.DEMO, 5: SUB_USER_IDS.CATALOG, 8: SUB_USER_IDS.DEMO },
  "dispute-claims": { 1101: SUB_USER_IDS.DEMO, 1102: SUB_USER_IDS.CATALOG },
  "copyright-infringements": { 1101: SUB_USER_IDS.DEMO, 1102: SUB_USER_IDS.CATALOG },
  "feature-request": { 7: SUB_USER_IDS.DEMO, 8: SUB_USER_IDS.CATALOG },
  "subuser-invoices": { 401: SUB_USER_IDS.DEMO, 402: SUB_USER_IDS.CATALOG, 403: SUB_USER_IDS.DEMO },
  statements: { 995: SUB_USER_IDS.DEMO, 994: SUB_USER_IDS.CATALOG, 993: SUB_USER_IDS.DEMO },
  "subuser-statements": { 995: SUB_USER_IDS.DEMO, 994: SUB_USER_IDS.CATALOG, 993: SUB_USER_IDS.DEMO },
};

const BY_TOKEN = {
  recipients: {
    "ecf3b95b-ee85-42a0-9062-fe30cc522853": SUB_USER_IDS.DEMO,
    "bc1a4c57-020f-4622-a805-2c1e84772684": SUB_USER_IDS.CATALOG,
    "f32a1c8b-3b4a-4b5a-833f-a8b7f2c8d9e1": SUB_USER_IDS.DEMO,
  },
};

export function resolveSubUserSeed(collection, row) {
  if (!row || typeof row !== "object") {
    return null;
  }

  if (row.sub_user != null && row.sub_user !== "") {
    return row.sub_user;
  }
  if (row.sub_user_id != null && row.sub_user_id !== "") {
    return row.sub_user_id;
  }

  const byId = BY_ID[collection];
  if (byId && row.id != null && byId[row.id] != null) {
    return byId[row.id];
  }

  const byToken = BY_TOKEN[collection];
  if (byToken && row.token && byToken[row.token] != null) {
    return byToken[row.token];
  }

  return null;
}

export function applySubUserSeedToRows(collection, rows) {
  return (rows || []).map(row => {
    const subUser = resolveSubUserSeed(collection, row);
    if (subUser == null) {
      return row;
    }
    return { ...row, sub_user: subUser };
  });
}
